import styled from "styled-components";

export const DemoraPacienteContainer = styled.div`
  width: 100%;
  height: calc(100vh - 8vh);
  overflow: scroll;
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const DemoraPacienteBody = styled.div`
  width: 100%;
  height: ${({ showLista }) =>
    showLista ? "calc(100vh + 10vh)" : "calc(80vh - 10px)"};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  padding-top: 35px;
  gap: 26px;
  /* z-index: -1; */
  .demopraPaciente-text-center {
    text-align: center;
    width: 298px;
  }
  .demopraPaciente-underline {
    text-decoration: underline;
    cursor: pointer;
  }
  .demora-tituloListaPacientes {
    display: flex;
    gap: 10px;
    align-items: center;
    height: 10px;
    width: 360px;
  }
  @media (max-height: 800px) {
    height: calc(100% + 14vh);
  }
`;

export const DemoraPacienteListaContainer = styled.div`
  position: relative;
  width: 360px;
  max-height: 190px;
  overflow-x: none;
  overflow-y: scroll;
  display: grid;
  gap: 20px;
`;
export const DemoraPacienteListaElemento = styled.div`
  display: grid;
  grid-template-columns: 70px 110px 140px;
  grid-template-columns: ${({ turnoPaciente }) =>
    turnoPaciente ? "70px 250px" : "70px 110px 140px"};

  color: ${({ colorEstado }) =>
    colorEstado ? "var(--color-broccoli)" : "var(--color-latex10)"};
`;

export const DemoraPacienteBotones = styled.div`
  /* position: absolute; */
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DemoraBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const BtnRecepcionados = styled.button`
  width: 276px;
  height: 52px;
  border-radius: 8px;
  box-shadow: 0px 90.239px 72.192px 0px rgba(0, 0, 0, 0.07),
    0px 37.7px 30.16px 0px rgba(0, 0, 0, 0.05),
    0px 20.156px 16.125px 0px rgba(0, 0, 0, 0.04),
    0px 11.299px 9.04px 0px rgba(0, 0, 0, 0.04),
    0px 6.001px 4.801px 0px rgba(0, 0, 0, 0.03),
    0px 2.497px 1.998px 0px rgba(0, 0, 0, 0.02);
`;
export const BtnAnunciarme = styled.button`
  width: 150px;
  height: 52px;
  border-radius: 8px;
  box-shadow: 0px 90.239px 72.192px 0px rgba(0, 0, 0, 0.07),
    0px 37.7px 30.16px 0px rgba(0, 0, 0, 0.05),
    0px 20.156px 16.125px 0px rgba(0, 0, 0, 0.04),
    0px 11.299px 9.04px 0px rgba(0, 0, 0, 0.04),
    0px 6.001px 4.801px 0px rgba(0, 0, 0, 0.03),
    0px 2.497px 1.998px 0px rgba(0, 0, 0, 0.02);
`;
